export const useUniformRect = (selector) => {
  const { renderer } = useTresContext()

  const { onBeforeLoop, onLoop, onAfterLoop } = useRenderLoop()

  const uniforms = {
    uRectLeft: { value: 0 },
    uRectTop: { value: 0 },
    uRectWidth: { value: 1 },
    uRectHeight: { value: 1 },
  }

  const rect = useElementRect(selector)
  // const rect = useElementRectV1(selector)

  const update = () => {
    if (!rect) return
    const dpr = window.devicePixelRatio

    uniforms.uRectLeft.value = parseFloat(rect.left) * dpr
    uniforms.uRectTop.value = parseFloat(rect.top) * dpr
    uniforms.uRectWidth.value = parseFloat(rect.width) * dpr
    uniforms.uRectHeight.value = parseFloat(rect.height) * dpr
  }
  onBeforeLoop(update)
  onLoop(update)
  onAfterLoop(update)
  return uniforms
}
